export default function onPointerPress(callback) {
  this.input.onDown.add(() => callback());
}
